import React from "react";
import { takeFiveOverview } from "./TakeFivePageSelector";
import { TakeFiveSection } from "./TakeFiveSection";
import { TakeFiveView } from "./TakeFiveView";

export const TakeFiveSectionOverview = () => {
    return (
        <TakeFiveSection
            page={takeFiveOverview}
            pageView={TakeFiveView.Overview}
        />
    );
}